export const catchError = (ex, onError) => (dispatch) => {
  const genericLoaderId = 'genericLoader';

  if (ex.response) {
    ex.response.json().then((error) => dispatch(onError(error)));
  } else {
    dispatch(onError(ex));
  }
};
